import * as React from "react";

interface IProps {
	value: {
		name: string;
		archived: boolean;
	};
}

export const ContactPresenter: React.SFC<IProps> = (props) => {
	const displayName = `${props.value.archived ? `${props.value.name} (archived)` : props.value.name}`;
	return (
		<span>{displayName}</span>
	);
};
